import 'babel-polyfill';
import Controller from './Controller/Controller';
import PageController from './Controller/PageController';

$('[data-equalizer]').on('postequalized.zf.equalizer', (e) =>  {
  $(e.currentTarget).addClass('equalized');
});

// Initialize Foundation JavaScript
$(document).foundation();

$(document).ready(function () {
  // Initialize Fancybox links
  $('a[class*=fancybox],a[class*=lightbox],a[rel*=fancybox]').fancybox({
      live: false
    }
  );

  // Initialize Controller
  Controller.initialize();
});

$(window).on('load', () => {
	Controller.onLoad();
});
